import { contactInfo } from '@/mocks/homeData';

export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">与我们沟通</span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">联系我们</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">{contactInfo.description}</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-primary-600"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-400 mb-0.5">电子邮箱</div>
                  <div className="text-sm font-medium text-foreground-900">{contactInfo.email}</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-wechat-line text-accent-600"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-400 mb-0.5">微信公众号</div>
                  <div className="text-sm font-medium text-foreground-900">{contactInfo.wechat}</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-qq-line text-secondary-600"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-400 mb-0.5">QQ群号</div>
                  <div className="text-sm font-medium text-foreground-900">{contactInfo.qq}</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-primary-600"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-400 mb-0.5">工作时间</div>
                  <div className="text-sm font-medium text-foreground-900">9:00 - 22:00</div>
                </div>
              </div>
            </div>

            <div className="mt-6 pt-6 border-t border-background-200/70">
              <p className="text-xs text-foreground-400">{contactInfo.tips}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}